export default "__VITE_ASSET__D7CVGo2W__"